import {useCallback, useState} from "react";
import {platformAPI} from "../../../api/axiosConfig";
import {useEvents} from "../../../lib/useEvents";

export function useDeleteSirenDefaultDeliveryMethods() {
    const [deleting, setDeleting] = useState(false);
    const [error, setError] = useState<string | null>(null);
    const {emit} = useEvents();

    const deleteDeliveryMethods = useCallback(async (id: string, context?: {clientID?: string; departmentID?: string}) => {
        setDeleting(true);
        setError(null);
        try {
            await platformAPI.delete(`api/siren/default-delivery-methods/${id}`);
            emit("siren:deliveryMethods:changed", {clientID: context?.clientID, departmentID: context?.departmentID, deleted: true});
        } catch {
            setError("Failed to delete default delivery methods");
            throw new Error("Failed to delete default delivery methods");
        } finally {
            setDeleting(false);
        }
    }, []);

    return {deleteDeliveryMethods, deleting, error};
}
